import { render, staticRenderFns } from "./Taxation.vue?vue&type=template&id=2ea56c8b&scoped=true&"
import script from "./Taxation.vue?vue&type=script&lang=js&"
export * from "./Taxation.vue?vue&type=script&lang=js&"
import style0 from "./Taxation.vue?vue&type=style&index=0&id=2ea56c8b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea56c8b",
  null
  
)

export default component.exports